import MapboxDraw, { DrawCustomMode } from "@mapbox/mapbox-gl-draw";
import { SnapPointMode } from "mapbox-gl-draw-snap-mode";

const { constants: Constants } = MapboxDraw;

/*
 * A modified draw_point mode that stays in draw_point when a point is created,
 * rather than moving back to simple_select and requiring the user to re-enter
 * draw point mode to create the next point.
 */
const drawPoint: DrawCustomMode = {
  ...SnapPointMode,

  onClick: function (this, state) {
    state.point.updateCoordinate("", state.snappedLng, state.snappedLat);

    this.map.fire(Constants.events.CREATE, {
      features: [state.point.toGeoJSON()],
    });

    state.point = this.newFeature({
      type: Constants.geojsonTypes.FEATURE,
      properties: {},
      geometry: {
        type: Constants.geojsonTypes.POINT,
        coordinates: [],
      },
    });
  },
};

export default drawPoint;
